import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import { connect } from 'react-redux'
import Popup from 'react-popup'
import {
  getOperations,
  selectOperation,
  returnToProductions
} from '../actions/ProductionActions'

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  productionId: state.router.location.query.production
    ? parseInt(state.router.location.query.production, 10) : false,
  production: state.production.production,
  operations: state.production.operations
})

const mapDispatchToProps = dispatch => ({
  getOperationsAction: (id) => dispatch(getOperations(id)),
  selectOperationAction: (id) => dispatch(selectOperation(id)),
  returnToProductionsAction: () => dispatch(returnToProductions())
})

const DONE_STATES = ['done', 'cancel']

const STATUS_LABELS = {
  done: 'Zakończona',
  other_workcenter: 'Inne stanowisko',
  waiting: 'Oczekuje',
  workcenter_locked: 'Stanowisko zajęte',
  not_ready: 'Jeszcze niegotowa'
}

class OperationsComponent extends React.Component {
  componentDidMount() {
    const { production, productionId, getOperationsAction } = this.props
    if (productionId && (!production || production.id !== productionId)) {
      getOperationsAction(productionId)
    }
  }

  rowClass = (operation) => {
    if (DONE_STATES.includes(operation.state)) return 'op-row done'
    return operation.can_start ? 'op-row current' : 'op-row locked'
  }

  /* Why an operation cannot be taken - each reason has its own message,
     so a step waiting for its turn is never reported as a wrong station. */
  blockedReason = (operation) => {
    if (DONE_STATES.includes(operation.state)) return 'done'
    if (!operation.is_mine) return 'other_workcenter'
    if (!operation.is_current) return 'waiting'
    if (operation.workcenter_locked) return 'workcenter_locked'
    return 'not_ready'
  }

  handleClick = (operation) => {
    if (operation.can_start) {
      this.props.selectOperationAction(operation.id)
      return
    }
    switch (this.blockedReason(operation)) {
      case 'done':
        Popup.alert('Ta operacja jest już zakończona.')
        break
      case 'other_workcenter':
        Popup.alert(`Ta operacja należy do stanowiska: ${operation.workcenter_name}.`)
        break
      case 'waiting':
        Popup.alert('Najpierw trzeba zakończyć poprzednie operacje.')
        break
      case 'workcenter_locked':
        Popup.alert(
          `Stanowisko ${operation.workcenter_name} jest zajęte przez zlecenie ${operation.locked_by_production_name} `
          + `(operacja ${operation.locked_by_operation_name}). Zakończ ją, aby rozpocząć inną.`)
        break
      default:
        Popup.alert('Ta operacja nie jest jeszcze gotowa do rozpoczęcia.')
    }
  }

  render() {
    const { authenticated, production, operations, returnToProductionsAction } = this.props
    if (!authenticated) return <Redirect to='/login' />
    if (!production) return null

    return (
      <>
        <div className="op-toolbar">
          <button type="button" className="secondary" onClick={returnToProductionsAction}>
            ‹ Wstecz
          </button>
          <div className="op-title">
            <span>Zlecenie</span>
            <b>{production.name}</b>
          </div>
          <div />
        </div>

        <p className="sub">
          {production.product_name} · zaplanowano {production.product_qty} szt.
        </p>

        <div className="op-list">
          {(operations || []).map((operation, index) => (
            <div
              key={operation.id}
              className={this.rowClass(operation)}
              onClick={() => this.handleClick(operation)}
            >
              <div className="op-row__seq">{index + 1}</div>
              <div className="op-row__main">
                <h5>{operation.name}</h5>
                <span className="op-row__wc">{operation.workcenter_name}</span>
              </div>
              <div className="op-row__meta">
                {operation.panel_display_state === 'break'
                  ? <span className="pill yellow">Przerwa</span>
                  : operation.panel_display_state === 'failure'
                  ? <span className="pill red">Awaria</span>
                  : operation.state === 'progress'
                  ? <span className="pill yellow">{operation.is_running ? 'W trakcie' : 'Wstrzymana'}</span>
                  : operation.can_start
                  ? <span className="pill yellow">Do wykonania</span>
                  : <span className={'pill ' + (this.blockedReason(operation) === 'done' ? 'green' : 'grey')}>
                      {STATUS_LABELS[this.blockedReason(operation)]}
                    </span>}
                <span className="op-row__qty">
                  {operation.qty_produced} / {operation.qty_production} szt.
                  {' '}(pozostało {Math.max(0, operation.qty_limit - operation.qty_produced - operation.qty_waste)})
                </span>
                {!operation.materials_available && !DONE_STATES.includes(operation.state) && (
                  <span className="pill red" title={(operation.missing_materials || []).join(', ')}>
                    ⚠ Brak: {(operation.missing_materials || [])[0]}
                    {operation.missing_materials && operation.missing_materials.length > 1
                      && ` +${operation.missing_materials.length - 1}`}
                  </span>
                )}
              </div>
            </div>
          ))}
          {(!operations || !operations.length) && <p>To zlecenie nie ma operacji.</p>}
        </div>
      </>
    )
  }
}

const Operations = connect(mapStateToProps, mapDispatchToProps)(OperationsComponent)
export default withRouter(Operations)
